import React from 'react';
import { Button, Form, FormInstance, message } from 'antd';
import useCreateProjectPresetsMutation from '../../hooks/mutations/useCreateProjectPresetsMutation';
import { Param } from '../../cliDataSchema';
import ProjectPresetInputFields from '../presets/ProjectPresetInputFields';

type Props = {
  paramGroupName: string;
  params: Param[];
  screens: any;
};

const CollectionForm: React.FC<Props> = ({
  paramGroupName,
  params,
  screens,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();
  const { createProjectPresets } = useCreateProjectPresetsMutation();

  const handleSubmit = async (
    values: Record<string, string>,
    form: FormInstance,
  ) => {
    try {
      setLoading(true);
      const projectName = values['name'];
      const paramsArray = Object.keys(values)
        .filter((key) => key !== paramGroupName && key !== 'name')
        .map((key) => {
          const param = params.find((param) => param.name === key);
          return {
            name: key,
            value: values[key],
            isSecret: param?.osep_generator_ui_is_secret || false,
          };
        });

      await createProjectPresets({
        name: projectName,
        type: paramGroupName,
        params: paramsArray,
      });

      message.success('Successfully created');
      form.resetFields();
    } catch (error) {
      message.error('Error creating project');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      onFinish={(values) => handleSubmit(values, form)}
      layout="vertical"
      style={{ marginBottom: 20 }}
    >
      <ProjectPresetInputFields
        paramGroupName={paramGroupName}
        params={params}
      />

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          style={{ width: !screens.md ? '100%' : 'auto' }}
        >
          Create Presets
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CollectionForm;
